import Swiper, { Autoplay } from "swiper";

export function blockGallerySlider() {
  new Swiper(".gallery__swiper", {
    modules: [ Autoplay ],
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 10,
    speed: 5000,
    autoplay: {
      delay: 1000,
      disableOnInteraction: false,
    },
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      1025: {
        slidesPerView: 4,
      },
    },
  });
}
